/** `2026-09-10T08:15:00Z` → `2026-09-10 10:15` in the viewer's zone; '—' for missing values. */
export function fmtDate(iso: string | null | undefined): string {
  if (!iso) return '—';
  const d = new Date(iso);
  if (isNaN(d.getTime())) return iso;
  const p = (n: number) => String(n).padStart(2, '0');
  return `${d.getFullYear()}-${p(d.getMonth() + 1)}-${p(d.getDate())} ${p(d.getHours())}:${p(d.getMinutes())}`;
}

/**
 * Name order for every list. AUTH sorts its lists too, but the console may administer an instance that
 * predates that (an environment picker can point at an older release), so the page it shows is sorted
 * again here — within the page only; ordering across pages is the API's job.
 */
export const byName =
  <T>(name: (x: T) => string) =>
  (a: T, b: T) =>
    name(a).localeCompare(name(b));

/** `[...items].sort(byName(...))` without the copy at every call site. */
export const sortedByName = <T>(items: readonly T[], name: (x: T) => string): T[] =>
  [...items].sort(byName(name));

export const GUID_RE = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

export const isGuid = (s: string): boolean => GUID_RE.test(s.trim());

export { copyText } from '@nyce/admin-kit/console';
